<template>
    <div>
        <b-table v-if="showTable && items.length > 0" 
        :items="items"
        :fields="fields"
        thead-class="d-none"
        tbody-class="forecast-history"
        tbody-tr-class="forecast-history-row"
        sticky-header="500px">
        <template v-slot:cell(estimateTime)="data">
                <span style='color: #a0283e' v-b-tooltip.hover :title='formatDateTime(data.item.estimateTime)' >{{ formatTime(data.item.estimateTime) }}</span>
        </template>

        <template v-slot:cell(eventTime)="data">
                <span v-b-tooltip.hover :title='formatDateTime(data.item.eventTime)' >{{ formatTime(data.item.eventTime) }}</span>
        </template>

        </b-table>

        <span v-else>{{$t('timetables.prediction_history.no_historical_data')}} </span>

    </div>
</template>

<script>

import timetable from '@/store/timetable/timetable'
import moment from 'moment';

export default {
    name: "PredictionHistory",
    props: {
        stopId: String,
        routeId: String, 
        lineId: String,
        passingTime: Object
    },
    data() {
        return {
        showTable: false,
        fields:[
            {key: "estimateTime"},
            {key: "status"},
            {key: "eventTime"},
            {key: "sourceSystem"}
        ] 
    } 
        
    },
    computed: {
        items() {
            return this.$store.state.timetable.predictionHistory.list
        }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }

        if(this.stopId && this.routeId && this.lineId && this.passingTime){
            this.showTable = true;
            this.$store.dispatch('timetable/getPredictionHistory', {stop: this.stopId, route: this.routeId, lineId: this.lineId, passingTime: this.passingTime})
        } else {
            this.showTable = false;
        }
    },
    methods: {
        formatTime(value){
            var time = new moment(value, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('HH:mm:ss');
            if (time.startsWith('Invalid')) {
                return '';
            }
            return time;
        },
        formatDateTime(value){
            var time = new moment(value, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm:ss');
            if (time.startsWith('Invalid')) {
                return '';
            }
            return time;
        }
    }
}
</script>

<style lang="scss">
.forecast-history-row {
  color: #515151;
  font-family: Verdana,Arial,Helvetica,sans-serif;
  font-size: 9px;
  font-weight: bold;

  border: 1px solid #ccc;
  td {
    vertical-align: top !important;
    background-color: #ffffff;
  }

}

.forecast-history tr.forecast-history-row td {
  padding: 3px 5px;
}
</style>